export default __webpack_public_path__ + "static/media/loginImage.51adbaa4.png";